(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flash-sale"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { return String(n).padStart(2, '0'); }
    function parse(v) { if (!v) return null; var t = new Date(v).getTime(); return isNaN(t) ? null : t; }

    function updateBtn(root, form) {
      var btn = form.querySelector('[data-fs-buy]');
      if (!btn || btn.getAttribute('data-busy')) return;
      var panel = form.closest('[data-fs-panel]');
      var st = panel ? panel.getAttribute('data-state') : 'live';
      var sel = form.querySelector('[data-fs-size]');
      if (root.getAttribute('data-lock') === 'true' && st && st !== 'live') {
        btn.disabled = true;
        btn.textContent = st === 'ended' ? root.getAttribute('data-ended-text') : root.getAttribute('data-locked-text');
        return;
      }
      if (sel && !sel.value) {
        btn.disabled = true;
        btn.textContent = btn.getAttribute('data-prompt');
      } else {
        btn.disabled = false;
        btn.textContent = btn.getAttribute('data-label');
      }
    }

    function initDrawerForm(root, form) {
      var mode = form.getAttribute('data-after-add');
      form.addEventListener('submit', function (e) {
        var btn = form.querySelector('button[type="submit"]');
        if (btn && btn.disabled) { e.preventDefault(); return; }
        if (mode !== 'drawer' && mode !== 'cart') return;
        var drawer = document.querySelector('cart-drawer');
        var isDawn = !!drawer && typeof drawer.renderContents === 'function';
        var isPrestige = !!drawer && !isDawn && typeof drawer.show === 'function';
        if (!isDawn && !isPrestige) return; /* fallback: submit biasa ke /cart */
        e.preventDefault();
        btn.disabled = true;
        btn.setAttribute('data-busy', '1');
        btn.textContent = 'Menambahkan…';

        var doc = document.documentElement;
        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var fd = new FormData(form);

        if (isPrestige) {
          var sections = [];
          doc.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
          doc.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
          fd.set('sections', sections.join(','));
          fd.set('sections_url', base + 'variants/' + fd.get('id'));
        } else if (typeof drawer.getSectionsToRender === 'function') {
          fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
          fd.append('sections_url', window.location.pathname);
        }

        function finish(errText) {
          if (isPrestige) doc.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
          function reset() {
            btn.removeAttribute('data-busy');
            var sel = form.querySelector('[data-fs-size]');
            if (sel) sel.selectedIndex = 0;
            updateBtn(root, form);
          }
          if (errText) {
            btn.textContent = errText;
            setTimeout(reset, 2000);
          } else {
            reset();
          }
        }

        fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
          body: fd
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
          .then(function (res) {
            if (!res.ok || res.json.status) { throw new Error('add failed'); }
            if (isDawn) { drawer.renderContents(res.json); return; }
            return fetch(base + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              cart.sections = res.json.sections;
              doc.dispatchEvent(new CustomEvent('cart:change', {
                bubbles: true,
                detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cart }
              }));
            });
          })
          .then(function () { finish(''); })
          .catch(function () { finish('Gagal, coba lagi'); });
      });
    }

    function initChips(panel) {
      var chips = panel.querySelectorAll('[data-fs-chip]');
      var items = panel.querySelectorAll('[data-fs-item]');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var type = chip.getAttribute('data-fs-chip');
          chips.forEach(function (c) {
            var on = c === chip;
            c.classList.toggle('is-active', on);
            c.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          items.forEach(function (it) {
            it.hidden = !!type && (it.getAttribute('data-cats') || '').indexOf('|' + type + '|') < 0;
          });
        });
      });
    }

    function initRoot(root) {
      if (root.getAttribute('data-fs-ready')) return;
      root.setAttribute('data-fs-ready', '1');
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-fs-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-fs-panel]'));
      var cd = root.querySelector('[data-fs-cd]');
      var cdLabel = root.querySelector('[data-fs-cd-label]');
      var cdTime = root.querySelector('[data-fs-cd-time]');
      var current = -1;

      panels.forEach(initChips);
      root.querySelectorAll('.fs-form').forEach(function (f) { initDrawerForm(root, f); });
      root.querySelectorAll('[data-fs-size]').forEach(function (sel) {
        var form = sel.closest('form');
        sel.addEventListener('change', function () { updateBtn(root, form); });
      });

      function activate(i) {
        if (i < 0 || i >= tabs.length) return;
        current = i;
        tabs.forEach(function (t, k) {
          var on = k === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          if (panels[k]) panels[k].hidden = !on;
        });
      }

      function stateOf(tab, now) {
        var s = parse(tab.getAttribute('data-start')), e = parse(tab.getAttribute('data-end'));
        if (s !== null && now < s) return 'next';
        if (e !== null && now >= e) return 'ended';
        return 'live';
      }

      function fmt(diff) {
        var d = Math.floor(diff / 864e5);
        var t = pad(Math.floor(diff % 864e5 / 36e5)) + ':' + pad(Math.floor(diff % 36e5 / 6e4)) + ':' + pad(Math.floor(diff % 6e4 / 1e3));
        return d > 0 ? d + 'h ' + t : t;
      }

      function refresh() {
        var now = Date.now();
        var liveIdx = -1, nextIdx = -1;
        tabs.forEach(function (tab, k) {
          var st = stateOf(tab, now);
          var changed = tab.getAttribute('data-state') !== st;
          tab.setAttribute('data-state', st);
          var label = root.getAttribute(st === 'live' ? 'data-live-text' : st === 'next' ? 'data-next-text' : 'data-ended-tab');
          var node = tab.querySelector('[data-fs-tab-state]');
          if (node && node.textContent !== label) node.textContent = label;
          if (st === 'live' && liveIdx < 0) liveIdx = k;
          if (st === 'next' && nextIdx < 0) nextIdx = k;
          if (changed && panels[k]) {
            panels[k].setAttribute('data-state', st);
            panels[k].querySelectorAll('.fs-form').forEach(function (f) { updateBtn(root, f); });
          }
        });

        if (current < 0 && tabs.length) {
          activate(liveIdx >= 0 ? liveIdx : (nextIdx >= 0 ? nextIdx : tabs.length - 1));
        }

        if (!cd) return;
        var target = null, label = '';
        if (liveIdx >= 0) {
          target = parse(tabs[liveIdx].getAttribute('data-end'));
          label = root.getAttribute('data-cd-live');
        } else if (nextIdx >= 0) {
          target = parse(tabs[nextIdx].getAttribute('data-start'));
          label = root.getAttribute('data-cd-next');
        }
        if (target === null) {
          if (tabs.length && liveIdx < 0 && nextIdx < 0) {
            cd.hidden = false; cdLabel.textContent = root.getAttribute('data-cd-done'); cdTime.textContent = '';
          } else { cd.hidden = true; }
          return;
        }
        cd.hidden = false;
        cdLabel.textContent = label;
        cdTime.textContent = fmt(Math.max(0, target - now));
      }

      tabs.forEach(function (tab, k) {
        tab.addEventListener('click', function () { activate(k); });
      });

      refresh();
      setInterval(refresh, 1000);
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-fs]').forEach(initRoot);
    }

    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var tab = e.target && e.target.matches && e.target.matches('[data-fs-tab]') ? e.target : null;
      if (tab) tab.click();
    });
    window.addEventListener('pageshow', function () {
      document.querySelectorAll('[data-fs-size]').forEach(function (s) { s.dispatchEvent(new Event('change')); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sales-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { return String(n).padStart(2, '0'); }

    function initCountdown(el) {
      var end = new Date(el.getAttribute('data-end')).getTime();
      if (isNaN(end)) { el.hidden = true; return; }
      var d = el.querySelector('[data-sl-d]'), h = el.querySelector('[data-sl-h]'),
          m = el.querySelector('[data-sl-m]'), s = el.querySelector('[data-sl-s]');
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          el.classList.add('is-expired');
          var label = el.querySelector('.sl-countdown__label');
          var txt = el.getAttribute('data-expired');
          if (label && txt) label.textContent = txt;
          return false;
        }
        d.textContent = pad(Math.floor(diff / 864e5));
        h.textContent = pad(Math.floor(diff % 864e5 / 36e5));
        m.textContent = pad(Math.floor(diff % 36e5 / 6e4));
        s.textContent = pad(Math.floor(diff % 6e4 / 1e3));
        return true;
      }
      if (tick()) {
        var id = setInterval(function () { if (!tick()) clearInterval(id); }, 1000);
      }
    }

    function initCopy(btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-sl-copy');
        var note = btn.querySelector('small') || btn;
        var old = note.textContent;
        function done() {
          note.textContent = btn.getAttribute('data-copied');
          setTimeout(function () { note.textContent = old; }, 2000);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          var t = document.createElement('textarea');
          t.value = code; document.body.appendChild(t); t.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(t); done();
        }
      });
    }

    function initSticky(root) {
      var bar = root.querySelector('[data-sl-sticky]');
      if (!bar || !('IntersectionObserver' in window)) return;
      var hero = root.querySelector('.sl-hero');
      var list = root.querySelector('[data-sl-products]');
      var seen = { hero: true, list: false };
      function update() { bar.hidden = seen.hero || seen.list; }
      function watch(node, key) {
        if (!node) { seen[key] = false; return; }
        new IntersectionObserver(function (e) { seen[key] = e[0].isIntersecting; update(); }, { threshold: 0.15 }).observe(node);
      }
      watch(hero, 'hero');
      watch(list, 'list');
      update();
    }

    function initDrawerForm(form) {
      var mode = form.getAttribute('data-after-add');
      if (mode !== 'drawer' && mode !== 'cart') return;
      form.addEventListener('submit', function (e) {
        var drawer = document.querySelector('cart-drawer');
        var isDawn = !!drawer && typeof drawer.renderContents === 'function';
        var isPrestige = !!drawer && !isDawn && typeof drawer.show === 'function';
        if (!isDawn && !isPrestige) return; /* fallback: submit biasa ke /cart */
        var btn = form.querySelector('button[type="submit"]');
        e.preventDefault();
        if (btn && btn.disabled) return;
        var label = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Menambahkan…'; }

        var doc = document.documentElement;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var fd = new FormData(form);

        if (isPrestige) {
          var sections = [];
          doc.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
          doc.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
          fd.set('sections', sections.join(','));
          fd.set('sections_url', root + 'variants/' + fd.get('id'));
        } else if (typeof drawer.getSectionsToRender === 'function') {
          fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
          fd.append('sections_url', window.location.pathname);
        }

        function finish(errText) {
          if (isPrestige) doc.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
          if (!btn) return;
          if (errText) {
            btn.textContent = errText;
            setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2000);
          } else {
            var sel = form.querySelector('[data-sl-size]');
            if (sel) {
              /* kembalikan ke kondisi awal: dropdown kosong, tombol nonaktif */
              sel.selectedIndex = 0;
              sel.dispatchEvent(new Event('change'));
            } else {
              btn.textContent = label;
              btn.disabled = false;
            }
          }
        }

        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
          body: fd
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
          .then(function (res) {
            if (!res.ok || res.json.status) { throw new Error('add failed'); }
            if (isDawn) { drawer.renderContents(res.json); return; }
            return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              cart.sections = res.json.sections;
              doc.dispatchEvent(new CustomEvent('cart:change', {
                bubbles: true,
                detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cart }
              }));
            });
          })
          .then(function () { finish(''); })
          .catch(function () { finish('Gagal, coba lagi'); });
      });
    }

    function initSize(select) {
      var form = select.closest('form');
      var btn = form && form.querySelector('[data-sl-buy]');
      if (!btn) return;
      function update() {
        var ok = !!select.value;
        btn.disabled = !ok;
        btn.textContent = ok ? btn.getAttribute('data-label') : btn.getAttribute('data-prompt');
      }
      select.addEventListener('change', update);
      update();
    }

    function init(root) {
      (root || document).querySelectorAll('[data-sl-size]').forEach(initSize);
      (root || document).querySelectorAll('.sl-card__form').forEach(initDrawerForm);
      (root || document).querySelectorAll('[data-sl-countdown]').forEach(initCountdown);
      (root || document).querySelectorAll('[data-sl-copy]').forEach(initCopy);
      (root || document).querySelectorAll('[data-sl]').forEach(initSticky);
    }

    init(document);
    window.addEventListener('pageshow', function () {
      document.querySelectorAll('[data-sl-size]').forEach(function (s) { s.dispatchEvent(new Event('change')); });
    });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
